import Helmet from 'react-helmet'

import { ChargeUtils } from 'utils'
import { Nav, Button } from 'components'
import { API_BASE } from 'consts'

import './upgradeToPlus.scss'

export default class UpgradeToPlus extends React.Component {
  static contextTypes = {
    currentUser: React.PropTypes.object
  }

  renderHeader() {
    return (
      <div className="upgradetoplus__header">
        <div className="upgradetoplus__background-shape-container">
          <div className="upgradetoplus__background-shape upgradetoplus__background-shape--one"></div>
        </div>
        <div className="upgradetoplus__background-shape-container">
          <div className="upgradetoplus__background-shape upgradetoplus__background-shape--two"></div>
        </div>
        <div className="upgradetoplus__headline--new">
          <h2 className="upgradetoplus__headline--new__title">
            Get the most powerful SEO tools available on Shopify
          </h2>
          <h3 className="upgradetoplus__headline--new__deal">
            $20/month, 14 day free trial
          </h3>
          <div className="upgradetoplus__headline--new__cta">
            <Button label="Start your free trial"
              buttonType="primary"
              onTouchTap={ () => { ChargeUtils.upgrade(this.context.currentUser.accessToken, "top") } }
            />
          </div>
        </div>
      </div>
    )
  }

  render() {
    window.location.replace(`${API_BASE}/v3ui/pricing`)
    
    return (
      <div>
        <Helmet title='Plug in SEO - Upgrade to Plus' />
        <Nav toolbarTitleText='Upgrade to Plus' />

        <div className='upgradetoplus'>
          {this.renderHeader()}

          <div className='upgradetoplus__fixed-bottom'>
            <div className='upgradetoplus__body'>
              <div className='upgradetoplus__body__callout'>
                <h2  className="upgradetoplus__body__callout-header">Big improvements to your SEO out-of-the-box <br/>...plus the most powerful control of your SEO available on Shopify</h2>
                <ul className='icon-font-list xlarge-spacing--top'>
                  <li className='icon-font-list__list-item icon-font-list__list-item--check'><h4>Install Plug in SEO Plus in your theme to benefit from improved SEO straight away</h4></li>
                  <li className='icon-font-list__list-item icon-font-list__list-item--check'>When you’re ready to refine your SEO, use time-saving features unavailable in any other Shopify app</li>
                  <li className='icon-font-list__list-item icon-font-list__list-item--check'>Free installation and premium support</li>
                  <li className='icon-font-list__list-item icon-font-list__list-item--check'>Constantly updated as search engines change</li>
                </ul>
                <h3  className="upgradetoplus__body__callout-price">$20/month, free installation</h3>
                <Button
                  label="Upgrade to Plug in SEO Plus"
                  buttonType="cta"
                  onTouchTap={ () => { ChargeUtils.upgrade(this.context.currentUser.accessToken, "top") } }
                />
                <p className="paragraph body2">If you don&apos;t love it, cancel and go back to Plug in SEO Free anytime</p>
              </div>
              <hr/>

              <div className="upgradetoplus__body__benefit-container">
                <h2>Add Structured Data to appear prominently in searches and get more clicks</h2>
                <p className="paragraph">Adding the Structured Data code throughout your shop lets search engines accurately identify things like a product name, ratings and company information.</p>
                <p className="paragraph">You&apos;ll be rewarded by search engines displaying more information about your products, company and blog in search results just like this...</p>
                <img src='https://dropshare-daniel.s3-eu-west-1.amazonaws.com/3EftWHqjFW.png'/>
                <p className="paragraph">Plug in SEO Plus delivers the most comprehensive range of structured data support with no extra work for you.</p>
                <p className="paragraph">Go further than just pages and see your...</p>
                <ul className="list">
                  <li className="list__item--sm">Products</li>
                  <li className="list__item--sm">Reviews</li>
                  <li className="list__item--sm">Site name</li>
                  <li className="list__item--sm">Sitelinks Searchbox</li>
                  <li className="list__item--sm">Logo, Social profile links</li>
                  <li className="list__item--sm">Breadcrumbs, Articles</li>
                </ul>
                <p className="paragraph">...all appearing in search results to give you the most chance of getting clicked.</p>
              </div>
              <hr/>

              <div className="upgradetoplus__body__benefit-container">
                <div className='upgradetoplus__body__alignedimage'>
                  <img src='https://dropshare-daniel.s3-eu-west-1.amazonaws.com/PqgehAYOhn.png'/>
                </div>
                <div className='upgradetoplus__body__alignedtext'>
                  <h2>Good page titles and meta descriptions throughout your shop - automatically</h2>
                  <p className="paragraph">Manually entering a page title and meta description for everything on your shop isn&apos;t a good use of SEO time. The best strategy is to use well-designed automatic defaults and then pinpoint any that you&apos;d like to tweak.</p>
                  <p className="paragraph">Plug in SEO Plus comes with well-designed defaults that we&apos;ve found to work well on the over 2,000 shops we&apos;ve optimized by hand. Plug in SEO Plus applies this to your shop, automatically.</p>
                </div>
              </div>
              <hr/>

              <div className="upgradetoplus__body__benefit-container">
                <div className='upgradetoplus__body__alignedtext'>
                  <h2>The most powerful control of your SEO available on Shopify</h2>
                  <p className="paragraph">For the first time on Shopify you can template, edit and bulk edit page titles and meta descriptions using any Liquid object in any of these places. No longer do you need to manually edit your SEO data- template it with the power of Liquid and tweak only those you’d like to.</p>
                  <ul className="list">
                    <li className="list__item">Create a template for each of your page types like product/collection/page/blog/article</li>
                    <li className="list__item">Edit and template the homepage, 404 and search special pages</li>
                    <li className="list__item">Edit and template individual products/collections/pages/blogs/articles</li>
                    <li className="list__item">Bulk editing of products/collections/pages/blogs/articles SEO data</li>
                  </ul>
                </div>
                <div className='upgradetoplus__body__alignedimage'>
                  <img src='https://dropshare-daniel.s3-eu-west-1.amazonaws.com/KUdyWYvrUt.png' />
                </div>
              </div>
              <hr/>

              <div className="upgradetoplus__body__benefit-container">
                <div className='upgradetoplus__body__alignedimage'>
                  <img src='https://dropshare-daniel.s3-eu-west-1.amazonaws.com/ydyKQQRapa.jpg' />
                </div>
                <div className='upgradetoplus__body__alignedtext'>
                  <h2>Free installation and premium support</h2>
                  <p className="paragraph">Our over 80,000 users of Plug in SEO know how great our support is. Upgrade to Plug in SEO Plus and you’ll benefit from even more in-depth, premium support and free installation.</p>
                  <p className="paragraph">We value providing the right answers to your questions rather than closing support tickets. Our Plus users call on us for everything from updating their theme to asking general SEO questions.</p>
                </div>
              </div>
              <hr/>

              <div className='upgradetoplus__body__callout'>
                <h2 className="upgradetoplus__body__callout-header">Ready to improve your SEO out-of-the-box and get the most powerful control of your SEO available on Shopify?</h2>
                <h3 className="upgradetoplus__body__callout-price">$20/month, free installation</h3>
                <Button
                  label="Upgrade to Plug in SEO Plus"
                  buttonType="cta"
                  onTouchTap={ () => { ChargeUtils.upgrade(this.context.currentUser.accessToken, "bottom") } }
                />
                <p className="paragraph body2">If you don&apos;t love it, cancel and go back to Plug in SEO Free anytime</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/plus/UpgradeToPlus.js